export function isEnabledPrompt(promptKey) {
  return window.ai
    && window.ai.chat
    && window.ai.chat.features.emailInteractions
    && window.ai.chat.activePromptKeys.includes(promptKey);
}
